export const LOGIN_REQUEST = "@@login.request";
export const LOGIN_SUCCESS = "@@login.success";
export const LOGIN_FAILURE = "@@login.failure";

export const REFRESH_TOKEN_REQUEST = "@@LOGIN.REFRESH_TOKEN_REQUEST";
export const REFRESH_TOKEN_SUCCESS = "@@LOGIN.REFRESH_TOKEN_SUCCESS";
export const REFRESH_TOKEN_FAILURE = "@@LOGIN.REFRESH_TOKEN_FAILURE";

export const SET_TOKEN_REFRESH_TIMER = "@@LOGIN.SET_TOKEN_REFRESH_TIMER";
